<h1><a href="/admin-home">Admin</a> - Historical Monthly Billing Report</h1>

<section>
    <mat-form-field>
        <mat-label>Year</mat-label>
        <mat-select id="filterType" required class="select" [(ngModel)]="selectedYear" (selectionChange)="viewReport()">
            @for(yr of yearsList; track yr){
            <mat-option [value]="yr">
                {{yr}}
            </mat-option>
            }
        </mat-select>
    </mat-form-field> &nbsp;&nbsp;
    <mat-form-field>
        <mat-label>Month</mat-label>
        <mat-select id="filterType" required class="select" [(ngModel)]="selectedMonth"
            (selectionChange)="viewReport()">
            @for(m of monthsList; track m){
            <mat-option [value]="m.name">
                {{m.name}}
            </mat-option>
            }
        </mat-select>
    </mat-form-field> &nbsp;&nbsp;
    <mat-form-field>
        <mat-label>Report Type</mat-label>
        <mat-select id="filterType" required class="select" [(ngModel)]="selectedType" (selectionChange)="viewReport()">
            @for(t of typesList; track t){
            <mat-option [value]="t.typeCode">
                {{t.typeName}}
            </mat-option>
            }
        </mat-select>
    </mat-form-field> &nbsp;&nbsp;
    <mat-form-field>
        <mat-label>Country</mat-label>
        <mat-select id="filterCountry" required class="select" [(ngModel)]="selectedCountry"
            (selectionChange)="viewReport()">
            @for (c of countriesList; track c) {
            <mat-option [value]="c.countryCode">
                {{c.countryName}}
            </mat-option>
            }
        </mat-select>
    </mat-form-field>
</section>
<section>
    <p class="msg">{{ msg }}</p>
    <p class="errormsg">{{ errormsg }}</p>
    <p>{{ loading }}</p>

    <mat-form-field>
        <mat-label>Search</mat-label>
        <input matInput [(ngModel)]="searchText" (keyup)="applyFilter($event)" />
        @if(searchText) {
        <button matSuffix mat-icon-button aria-label="Clear search" (click)="clearSearch()">
            <mat-icon>close</mat-icon>
        </button>
        }
    </mat-form-field>

    &nbsp;&nbsp;
    <button mat-raised-button color="primary" (click)="exportToExcel()"> Export to Excel </button>

    <div class="report-table-container">
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

            @for(column of displayedColumns; track column) {
            <ng-container [matColumnDef]="column">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ column }}
                </th>

                <tr class="mat-mdc-row" *matNoDataRow>
                    <td class="mat-mdc-cell" [attr.colspan]="displayedColumns.length">
                        No data available for the selected fields
                    </td>
                </tr>

                @if(column === "Billing Eligibility Date" || column === "Billing Date") {
                <td mat-cell *matCellDef="let row">
                    {{ dateFormat(row[column]) }}
                </td>
                } @else if(column === "Monthly Cost" || column === "Monthly Billing Amount") {
                <td mat-cell *matCellDef="let row">
                    {{ row[column] | currency:'USD':'symbol':'1.2-2' }}
                </td>
                } @else {
                <td mat-cell *matCellDef="let row">
                    {{ row[column] }}
                </td>
                }

                <!-- Footer -->
                @if(column === "Monthly Billing Amount") {
                <td mat-footer-cell *matFooterCellDef>
                    {{ getFooterValue(column) | currency:'USD':'symbol':'1.2-2' }}
                </td>
                } @else if (column === "Tech Count" || column === "Subscription Count") {
                <td mat-footer-cell *matFooterCellDef>
                    {{ getFooterValue(column) | number }}
                </td>
                } @else {
                <td mat-footer-cell *matFooterCellDef>
                    {{ getFooterValue(column) }}
                </td>
                }

            </ng-container>
            }
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        </table>
    </div>

    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons>
    </mat-paginator>
    <br>
</section>